/* eslint no-underscore-dangle: ['error', { 'allow': [
_data, _mainCategory, _subCategory, _questions,
_formData, _attachmentsTitle, _attachments,
_showErrors, _submitStatus, _showFaq,
_email, _emailRegex,
] }] */
/* global globals */
import { EventEmitter } from 'events';
import assign from 'object-assign';
import get from 'lodash/get';
import AppDispatcher from '../dispatcher/AppDispatcher';
import Constants from '../constants/Constants';

const { ActionTypes } = Constants;

const CHANGE_EVENT = 'change';

//
let _data = {
  categories: {},
  questions: {},
  linkedQuestions: {},
  attachmentsTitles: {},
};
//
let _mainCategory = '';
let _subCategory = '';
let _questions = [];
let _formData = {};
let _attachmentsTitle = '';
let _attachments = {};
let _showErrors = false;
let _submitStatus = null;
let _showFaq = true;

let _email = '';
// From 'javascript/src/legacy/vendor/validate.js'
const _emailRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

const SuggestionsExtendedStore = assign({}, EventEmitter.prototype, {

  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  /**
   * @param {function} callback
   */
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  /**
   * @param {function} callback
   */
  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  /**
   * Set data from 'globals'
   */
  setData() {
    _data = get(globals, 'suggestion_questions_data', {});
    _email = get(globals, 'currentMember.email', '');
  },

  /**
   * @return {object}
   */
  getCategories() {
    return _data.categories;
  },

  /**
   * @param {string} value
   */
  setMainCategory(value) {
    _mainCategory = value;

    if (Object.prototype.hasOwnProperty.call(_data.attachmentsTitles, _mainCategory)) {
      _attachmentsTitle = _data.attachmentsTitles[_mainCategory];
    } else {
      _attachmentsTitle = '';
    }
  },

  /**
   * @return {string}
   */
  getMainCategory() {
    return _mainCategory;
  },

  /**
   * @param {string} value
   */
  setSubCategory(value) {
    _subCategory = value;
  },

  /**
   * @return {string}
   */
  getSubCategory() {
    return _subCategory;
  },

  /**
   * Set questions and form data for category and/or subcategory
   */
  setQuestionsAndFormData() {
    const questions = [];
    const formData = {};

    if (!_mainCategory
      || (!_subCategory
        && Object.prototype.hasOwnProperty.call(_data.categories.sub, _mainCategory)
      )
    ) {
      _questions = questions;
      _formData = formData;
      _showFaq = true;
      return;
    }

    if (_subCategory && Object.prototype.hasOwnProperty.call(_data.questions, _subCategory)) {
      _data.questions[_subCategory].forEach((item) => {
        if (_data.linkedQuestions
          && Object.prototype.hasOwnProperty.call(_data.linkedQuestions, item.id)
        ) {
          return;
        }

        formData[item.id] = null;
        questions.push(item);
      });
    }

    if (Object.prototype.hasOwnProperty.call(_data.questions, _mainCategory)) {
      _data.questions[_mainCategory].forEach((item) => {
        if (_data.linkedQuestions
          && Object.prototype.hasOwnProperty.call(_data.linkedQuestions, item.id)
        ) {
          return;
        }

        formData[item.id] = null;
        questions.push(item);
      });
    }

    _questions = questions;
    _formData = formData;
    _showFaq = false;
  },

  /**
   * Update form data
   */
  updateFormData(data) {
    Object.keys(data).forEach((question) => {
      _formData[question] = data[question] === '0' ? null : data[question];
    });
  },

  /**
   * Update questions to show/hide linked questions accordingly
   */
  updatedQuestionsWithLinked() {
    const questions = [];
    const formData = {};

    if (_subCategory && Object.prototype.hasOwnProperty.call(_data.questions, _subCategory)) {
      _data.questions[_subCategory].forEach((item) => {
        if (_data.linkedQuestions
          && Object.prototype.hasOwnProperty.call(_data.linkedQuestions, item.id)
        ) {
          let opened = false;
          Object.keys(_data.linkedQuestions[item.id]).forEach((question) => {
            if (Object.prototype.hasOwnProperty.call(_formData, question)
              && _data.linkedQuestions[item.id][question].includes(_formData[question])
            ) {
              opened = true;
            }
          });
          if (!opened) {
            return;
          }
        }

        formData[item.id] = _formData[item.id] || null;
        questions.push(item);
      });
    }

    if (Object.prototype.hasOwnProperty.call(_data.questions, _mainCategory)) {
      _data.questions[_mainCategory].forEach((item) => {
        if (_data.linkedQuestions
          && Object.prototype.hasOwnProperty.call(_data.linkedQuestions, item.id)
        ) {
          let opened = false;
          Object.keys(_data.linkedQuestions[item.id]).forEach((question) => {
            if (Object.prototype.hasOwnProperty.call(_formData, question)
              && _data.linkedQuestions[item.id][question].includes(_formData[question])
            ) {
              opened = true;
            }
          });
          if (!opened) {
            return;
          }
        }

        formData[item.id] = _formData[item.id] || null;
        questions.push(item);
      });
    }

    _questions = questions;
    _formData = formData;
  },

  /**
   * @return {array}
   */
  getFormDataEmptyAnswers() {
    const emptyAnswers = [];

    Object.keys(_formData).forEach((question) => {
      if (!_formData[question]) {
        emptyAnswers.push(Number(question));
      }
    });

    return emptyAnswers;
  },

  /**
   * Update "can't leave this field empty" errors
   */
  updateEmptyAnswersErrors(emptyAnswers) {
    _questions.forEach((question, index) => {
      // const questionCopy = question;
      if (emptyAnswers.includes(question.id)) {
        _questions[index].error = 'txt: Šis lauks nedrīkst palikt tukšs';
      } else if (question.error) {
        _questions[index].error = null;
      }
    });
  },

  /**
   * @return {array}
   */
  getQuestions() {
    return _questions;
  },

  /**
   * @return {object}
   */
  getFormData() {
    return _formData;
  },

  /**
   * @param {object} data
   */
  setAttachments(data) {
    _attachments = data;
  },

  /**
   * @return {object}
   */
  getAttachments() {
    return _attachments;
  },

  /**
   * @param {boolean} value
   */
  setShowErrors(value) {
    _showErrors = value;
  },

  /**
   * @return {boolean}
   */
  getShowErrors() {
    return _showErrors;
  },

  /**
   * @param {boolean} value
   */
  setSubmitStatus(value) {
    _submitStatus = value;
  },

  /**
   * @return {boolean}
   */
  getSubmitStatus() {
    return _submitStatus;
  },

  /**
   * @return {boolean}
   */
  getShowFaq() {
    return _showFaq;
  },

  /**
   * @return {boolean}
   */
  getAttachmentsTitle() {
    return _attachmentsTitle;
  },

  /**
   * @param {string} value
   */
  setEmail(value) {
    _email = value;
  },

  /**
   * @return {string}
   */
  getEmail() {
    return _email;
  },

  /**
   * @return {string}
   */
  getEmailError() {
    return _emailRegex.test(_email) ? '' : 'txt: E-pasts ievadīts nekorekti';
  },

});

//
SuggestionsExtendedStore.dispatchToken = AppDispatcher.register((action) => {
  switch (action.type) {
    case ActionTypes.SUGGESTIONS_EXTENDED_FORM_SUBMIT_SUCCESS: {
      SuggestionsExtendedStore.setSubmitStatus('success');
      SuggestionsExtendedStore.emitChange();
      break;
    }
    case ActionTypes.SUGGESTIONS_EXTENDED_FORM_SUBMIT_ERROR: {
      SuggestionsExtendedStore.setSubmitStatus('error');
      SuggestionsExtendedStore.emitChange();
      break;
    }
    default:
      // do nothing
  }
});

module.exports = SuggestionsExtendedStore;
